import type { Receiver } from "@ceeferenderer/itg-renderer-sdk";
import { process } from "./process";

export const receiver: Receiver = {
  receive: (_topic, data) => {
    process(data);
  },
};
